import { render, staticRenderFns } from "./RedemptionModal.vue?vue&type=template&id=1ce6ad9c&scoped=true"
import script from "./RedemptionModal.vue?vue&type=script&lang=js"
export * from "./RedemptionModal.vue?vue&type=script&lang=js"
import style0 from "./RedemptionModal.vue?vue&type=style&index=0&id=1ce6ad9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce6ad9c",
  null
  
)

export default component.exports